import React, { PropsWithChildren } from 'react';
import { BaseModalCloseButton, BaseModalContainer, BaseModalContent } from './BaseModal.styles';
import ModalOverlay from './ModalOverlay';
import XClose from 'app/icons/Monospaced/X/XClose';
import { cssVar } from 'styles/helper';
import PortalWrapper from 'molecules/PortalWrapper/PortalWrapper';

export interface BaseModalProps extends PropsWithChildren {
  visible: boolean;
  onClose: () => void;
  baseWidth: number | string;
  blockClose?: boolean;
  hideCloseButton?: boolean;
}

const BaseModal = ({
  visible,
  onClose,
  children,
  baseWidth,
  blockClose = false,
  hideCloseButton = false,
}: BaseModalProps): JSX.Element => {
  const modalCloseHandler = () => {
    if (!blockClose) {
      onClose();
    }
  };

  return (
    <PortalWrapper>
      <BaseModalContainer
        position='fixed'
        align='center'
        justify='center'
        className={visible ? 'visible' : ''}
        paddingSm={['spacing-none', 'spacing-3xl']}
        dataCy='base-modal'
      >
        <ModalOverlay onClick={modalCloseHandler} />
        <BaseModalContent
          $width={baseWidth}
          data-cy='base-modal-content'
        >
          {!hideCloseButton && (
            <BaseModalCloseButton
              onClick={modalCloseHandler}
              dataCy='base-modal-close-button'
            >
              <XClose
                width={20}
                color={cssVar('text-primary')}
              />
            </BaseModalCloseButton>
          )}
          {children}
        </BaseModalContent>
      </BaseModalContainer>
    </PortalWrapper>
  );
};

export default BaseModal;
